import { useTheme } from '@mui/material';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { FieldErrors, UseFormRegister } from 'react-hook-form';

import Button from '@/components/Button';
import InputField from '@/components/InputField';

import { CreateKitFormData } from '../schema';

const numericFieldProps = {
  type: 'number',
  textFieldProps: {
    inputProps: {
      step: '1',
      min: '0',
      pattern: '[0-9]*',
    },
  },
};

interface CreateKitStepBasicInfoProps {
  step: number;
  setCurrentStep: (step: number) => void;
  register: UseFormRegister<CreateKitFormData>;
  errors: FieldErrors<CreateKitFormData>;
  isDisabled: boolean;
}

const CreateKitStepBasicInfo = (props: CreateKitStepBasicInfoProps) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={3}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        pt: 1,
        px: 2,
        pb: 2,
        gap: 2,
        mt: 2,
      }}
    >
      <Grid size={{ xs: 12 }}>
        <InputField
          label="Nombre del Kit"
          name="name"
          register={props.register}
          errors={props.errors}
          sxInput={{ mt: 0 }}
          sxLabel={{ color: theme.palette.secondary.main, fontSize: '1rem' }}
          placeholder="Ej. Kit playera + pantalón"
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <InputField
          label="SKU del Kit"
          name="sku"
          register={props.register}
          errors={props.errors}
          sxInput={{ mt: 0 }}
          sxLabel={{ color: theme.palette.secondary.main, fontSize: '1rem' }}
          placeholder="Ej. KIT-PLAYERA-12345"
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <InputField
          label="Costo de venta"
          name="price"
          register={props.register}
          errors={props.errors}
          sxInput={{ mt: 0 }}
          sxLabel={{ color: theme.palette.secondary.main, fontSize: '1rem' }}
          {...numericFieldProps}
        />
      </Grid>

      <Grid container mt={2} justifyContent="flex-end">
        <Button disabled={props.isDisabled} onClick={() => props.setCurrentStep(props.step + 1)}>
          Continuar
        </Button>
      </Grid>
    </Paper>
  );
};

export default CreateKitStepBasicInfo;
